// extracted by mini-css-extract-plugin
export var sliderRange = "_rx-2";
export var sliderRoot = "_rx-0";
export var sliderThumb = "_rx-3";
export var sliderTrack = "_rx-1";